import { Routes, Route } from 'react-router-dom'
import React, { useEffect } from 'react'

import ShopRoutesModel from './model/shop'
import Lost from '@/components/default/lost'
import UnderConstruction from '@/components/default/under-construction'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '@/store/store'
import { verifyToken } from '@/services/api/auth/auth'
import Toast from '@/components/elements/toast'
import { logout } from '@/store/features/auth'
import { clearCart } from '@/store/features/cart'

const ControllRoutes: React.FC = () => {
	const { customer, token } = useSelector((state: RootState) => state.auth)
	const dispatch = useDispatch<AppDispatch>()

	useEffect(() => {
		const verifyTokenExpired = async () => {
			if (!token) {
				return
			}

			const response = await verifyToken(token)

			if (response.status === 401) {
				Toast({
					type: 'info',
					message: 'La sesión del usuario ha expirado, vuelva a ingresar',
				})
				dispatch(logout())
				dispatch(clearCart())
				return
			}
		}

		verifyTokenExpired()
	}, [token])

	return (
		<Routes>
			{ShopRoutesModel(customer, token)}

			<Route path='*' element={<Lost customer={customer} token={token} />} />
			<Route path='/under-construction' element={<UnderConstruction />} />
		</Routes>
	)
}

export default ControllRoutes
